import { render, staticRenderFns } from "./CategoriaCarrossel.vue?vue&type=template&id=0197a083&"
import script from "./CategoriaCarrossel.js?vue&type=script&lang=js&"
export * from "./CategoriaCarrossel.js?vue&type=script&lang=js&"
import style0 from "./CategoriaCarrossel.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
